// Swiper is imported already
if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productFormsQuantity = this.querySelectorAll('product-form input[name="quantity"]');
      this.quantityInputElements = this.querySelectorAll('quantity-input input[name="quantity"]');
      this.quantityInputElements?.forEach((element) =>
        element.addEventListener('change', (event) => {
          this.handleQuantityInput(event);
        })
      );
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput(event) {
      const newValue = event.target?.value;
      if (!newValue) return;

      this.productFormsQuantity.forEach((input) => (input.value = newValue));
      this.quantityInputElements.forEach((input) => (input.value = newValue));
    }
  }
  customElements.define('product-info', ProductInfo);
}

// cross sells
if (!customElements.get('cross-sell')) {
  class CrossSell extends HTMLElement {
    constructor() {
      super();
      this.discount = this.dataset.crossSellDiscount;
      this.initator = this.dataset.crossSellInit;
      this.freeProduct = this.dataset.crossSell;
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartNotification = document.querySelector('cart-notification');
      this.buttons = document.querySelector('[data-buttons]');

      this.multi = this.querySelector('[data-multi]');
      this.single = this.querySelector('[data-single]');
      this.singleInit = this.querySelector('[data-single-init]');
      this.multi.addEventListener('click', (event) => {
        this.addMulti();
      });
      this.single.addEventListener('click', (event) => {
        this.addSingle('free');
      });
      this.singleInit.addEventListener('click', (event) => {
        this.addSingle('init');
      });
      this.guardRemovals();
    }

    guardRemovals() {
      let buttons = document.querySelectorAll('[data-bundle-remove]');
      let otherButtons = document.querySelector('[data-buttons]');
      buttons.forEach(function(removeButton){
        removeButton.addEventListener('click', (event) => {
          if (buttons.length > 1) {
            if (otherButtons) {
              otherButtons.classList.remove('is-added');
              if (removeButton.dataset.bundleRemoveInit) {
                otherButtons.classList.add('has-free');
              } else {
                otherButtons.classList.add('has-product');
              }
            }
          }
          if (buttons.length < 2) {
            if (otherButtons) {
              otherButtons.classList.remove('is-added');
              otherButtons.classList.remove('has-product');
              otherButtons.classList.remove('has-free');
            }
          }
        });
      });
    }

    addMulti() {

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};
      object = {
        quantity: 1,
        id: parseFloat(this.freeProduct),
        properties: {
          "_cross": true,
          "_discount": this.discount,
          "_initator": this.initator,
          "_free": this.freeProduct,
          "_bundle": true
        }
      }
      items.push(object);

      let obj = {};
      obj = {
        quantity: 1,
        id: parseFloat(this.initator),
        properties: {
          "_bundle": true
        }
      }
      items.push(obj);
  
      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((parsedState) => {
  
        if (this.cartDrawer) {
          this.renderContents(parsedState);
          this.cartDrawer.open();
        }
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.buttons.classList.remove('has-product');
        this.buttons.classList.add('is-added');
        this.guardRemovals();
      });

    }

    addSingle(type) {

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};

      if (type == 'init') {
        object = {
          quantity: 1,
          id: parseFloat(this.freeProduct),
          properties: {
            "_cross": true,
            "_discount": this.discount,
            "_initator": this.initator,
            "_free": this.freeProduct,
            "_bundle": true
          }
        }
      } else {
        object = {
          quantity: 1,
          id: parseFloat(this.initator),
          properties: {
            "_bundle": true
          }
        }
      }

      items.push(object);
  
      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((parsedState) => {
  
        if (this.cartDrawer) {
          this.renderContents(parsedState);
          this.cartDrawer.open();
        }
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.buttons.classList.remove('has-product');
        this.buttons.classList.add('is-added');
        this.guardRemovals();
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '[data-cart-drawer]',
        },
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    renderContents(parsedState) {

      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        }
      });
  
      //Re-bind the close drawer buttons
      this.cartDrawer.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );

      this.handleDiscounts();
    }

    handleDiscounts() {
      let discountCode = localStorage.getItem('discounts_applied_updated');
      if (discountCode) {
        document.querySelectorAll('[data-storewide-discount]').forEach((discount) => {
          let newPrice = discount.querySelector('.price__item--compare').innerHTML;
          let oldPrice = discount.querySelector('.price__item--regular').innerHTML;
          discount.querySelector('.price__item--regular').innerHTML = newPrice;
          discount.querySelector('.price__item--compare').innerHTML = oldPrice;
          discount.querySelector('.price__item--compare').classList.remove('hidden');
  
        });
        document.querySelectorAll('[data-storewide-discount-bundle]').forEach((discount) => {
          let newPrice = discount.querySelector('[data-discount-new-price]').dataset.discountNewPrice;
          discount.querySelector('[data-discount-new-price]').innerHTML = newPrice;
        });
      }
    }

    close() {
      document.body.classList.remove('cart-drawer-is-open');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus();
    }


    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }
  customElements.define('cross-sell', CrossSell);
}
